
import axiosInstance from "./AxiosInstance";

export function getBankList(data) {
  return axiosInstance.post(`/listbank`, data);
}
export function deleteBank(data) {
  return axiosInstance.post(`/deletebank`, data);
}
export function createBank(data) {
  return axiosInstance.post(`/savebank`, data);
}
export function updateBank(data) {
  return axiosInstance.post(`/updatebank`, data);
}

export function getCaeCodeList(data) {
  return axiosInstance.post(`/listcaecode`, data);
}
export function deleteCaeCode(data) {
  return axiosInstance.post(`/deletecaecode`, data);
}
export function createCaeCode(data) {
  return axiosInstance.post(`/savecaecode`, data);
}
export function updateCaeCode(data) {
  return axiosInstance.post(`/updatecaecode`, data);
}

export function getPaymentMethodList(data) {
  return axiosInstance.post(`/listpaymentmethod`, data);
}
export function deletePaymentMethod(data) {
  return axiosInstance.post(`/deletepaymentmethod`, data);
}
export function createPaymentMethod(data) {
  return axiosInstance.post(`/savepaymentmethod`, data);
}
export function updatePaymentMethod(data) {
  return axiosInstance.post(`/updatepaymentmethod`, data);
}

export function getMaturityDatesList(data) {
  return axiosInstance.post(`/listmaturitydates`, data);
}
export function deleteMaturityDates(data) {
  return axiosInstance.post(`/deletematuritydates`, data);
}
export function createMaturityDates(data) {
  return axiosInstance.post(`/savematuritydates`, data);
}
export function updateMaturityDates(data) {
  return axiosInstance.post(`/updatematuritydates`, data);
}

export function getDeliveryMethodList(data) {
  return axiosInstance.post(`/listdeliverymethod`, data);
}
export function deleteDeliveryMethod(data) {
  return axiosInstance.post(`/deletedeliverymethod`, data);
}
export function createDeliveryMethod(data) {
  return axiosInstance.post(`/savedeliverymethod`, data);
}
export function updateDeliveryMethod(data) {
  return axiosInstance.post(`/updatedeliverymethod`, data);
}

export function getMoloniVehiclesList(data) {
  return axiosInstance.post(`/listvehicle`, data);
}
export function deleteMoloniVehicles(data) {
  return axiosInstance.post(`/deletevehicle`, data);
}
export function createMoloniVehicles(data) {
  return axiosInstance.post(`/savevehicle`, data);
}
export function updateMoloniVehicles(data) {
  return axiosInstance.post(`/updatevehicle`, data);
}

export function getDeductionList(data) {
  return axiosInstance.post(`/listdeduction`, data);
}
export function deleteDeduction(data) {
  return axiosInstance.post(`/deletededuction`, data);
}
export function createDeduction(data) {
  return axiosInstance.post(`/savededuction`, data);
}
export function updateDeduction(data) {
  return axiosInstance.post(`/updatededuction`, data);
}

export function getTaxList(data) {
  return axiosInstance.post(`/listtax`, data);
}
export function deleteTax(data) {
  return axiosInstance.post(`/deletetax`, data);
}
export function createTax(data) {
  return axiosInstance.post(`/savetax`, data);
}
export function updateTax(data) {
  return axiosInstance.post(`/updatetax`, data);
}
export function getTimeZoneList(data) {
  return axiosInstance.post(`/gettimezone`, data);
}

export function getUnitList(data) {
  return axiosInstance.post(`/listunit`, data);
}
export function deleteUnit(data) {
  return axiosInstance.post(`/deleteunit`, data);
}
export function createUnit(data) {
  return axiosInstance.post(`/saveunit`, data);
}
export function updateUnit(data) {
  return axiosInstance.post(`/updateunit`, data);
}

export function getTemplateList(data) {
  return axiosInstance.post(`/listtemplate`, data);
}
export function deleteTemplate(data) {
  return axiosInstance.post(`/deletetemplate`, data);
}
export function createTemplate(data) {
  return axiosInstance.post(`/savetemplate`, data);
}
export function updateTemplate(data) {
  return axiosInstance.post(`/updatetemplate`, data);
}

export function getDocumentSetList(data) {
  return axiosInstance.post(`/listdocumentset`, data);
}
export function deleteDocumentSet(data) {
  return axiosInstance.post(`/deletedocumentset`, data);
}
export function createDocumentSet(data) {
  return axiosInstance.post(`/savedocumentset`, data);
}
export function updateDocumentSet(data) {
  return axiosInstance.post(`/updatedocumentset`, data);
}

export function getWarehouseList(data) {
  return axiosInstance.post(`/listwarehouse`, data);
}
export function deleteWarehouse(data) {
  return axiosInstance.post(`/deletewarehouse`, data);
}
export function createWarehouse(data) {
  return axiosInstance.post(`/savewarehouse`, data);
}
export function updateWarehouse(data) {
  return axiosInstance.post(`/updatewarehouse`, data);
}

export function getProductPropertyList(data) {
  return axiosInstance.post(`/listproductproperty`, data);
}
export function deleteProductProperty(data) {
  return axiosInstance.post(`/deleteproductproperty`, data);
}
export function createProductProperty(data) {
  return axiosInstance.post(`/saveproductproperty`, data);
}
export function updateProductProperty(data) {
  return axiosInstance.post(`/updateproductproperty`, data);
}

export function getProductCategoryList(data) {
  return axiosInstance.post(`/listcategory`, data);
}
export function deleteProductCategory(data) {
  return axiosInstance.post(`/deletecategory`, data);
}
export function createProductCategory(data) {
  return axiosInstance.post(`/savecategory`, data);
}
export function updateProductCategory(data) {
  return axiosInstance.post(`/updatecategory`, data);
}

export function getProductPriceClassList(data) {
  return axiosInstance.post(`/listpriceclass`, data);
}
export function deleteProductPriceClass(data) {
  return axiosInstance.post(`/deletepriceclass`, data);
}
export function createProductPriceClass(data) {
  return axiosInstance.post(`/savepriceclass`, data);
}
export function updateProductPriceClass(data) {
  return axiosInstance.post(`/updatepriceclass`, data);
}

export function getListCountry(data) {
  return axiosInstance.get(`/listCountry`, data);
}

export function getAllBankAccountSync(data) {
  return axiosInstance.post(`/getallbank`, data);
}

export function getAllVehicleSync(data) {
  return axiosInstance.post(`/getallvehicle`, data);
}

export function getAllCaeSync(data) {
  return axiosInstance.post(`/getallcaecode`, data);
}
export function getAllPaymentMethodSync(data) {
  return axiosInstance.post(`/getpaymentmethod`, data);
}
export function getAllMaturityDatesSync(data) {
  return axiosInstance.post(`/getmaturitydates`, data);
}
export function getAllDeliveryMethodSync(data) {
  return axiosInstance.post(`/getdeliverymethod`, data);
}
export function getAllDeductionSync(data) {
  return axiosInstance.post(`/getalldeduction`, data);
}
export function getAllTaxSync(data) {
  return axiosInstance.post(`/getalltax`, data);
}

export function getAllUnitSync(data) {
  return axiosInstance.post(`/getallunit`, data);
}

export function getAllTemplateSync(data) {
  return axiosInstance.post(`/getalltemplate`, data);
}

export function getAllDocumentsetSync(data) {
  return axiosInstance.post(`/getalldocumentset`, data);
}

export function getAllWarehouseSync(data) {
  return axiosInstance.post(`/getallwarehouse`, data);
}

export function getAllProductPropertySync(data) {
  return axiosInstance.post(`/getallproductproperty`, data);
}

export function getAllCategorySync(data) {
  return axiosInstance.post(`/getallcategory`, data);
}

export function getAllPriceClassSync(data) {
  return axiosInstance.post(`/getpriceclass`, data);
}

export function getAllSalesmenSync(data) {
  return axiosInstance.post(`/getallsalesmen`, data);
}

export function getAllSupplierSync(data) {
  return axiosInstance.post(`/getallsupplier`, data);
}

export function getAllProductSync(data) {
  return axiosInstance.get(`/getallproduct`, data);
}

export function getAllCountrySync(data) {
  return axiosInstance.get(`/getCountry`, data);
}

export function getListMainproduct(data) {
  return axiosInstance.post(`/listproduct`, data);
}

export function getViewMainproduct(data) {
  return axiosInstance.post(`/viewproduct`, data);
}

export function getAllMainProductSync(data) {
  return axiosInstance.post(`/getallproduct`, data);
}

export function getListSalesmenList(data) {
  return axiosInstance.post(`/listsalesmen`, data);
}
export function deleteListSalesmen(data) {
  return axiosInstance.post(`/deletesalesmen`, data);
}
export function createListSalesmen(data) {
  return axiosInstance.post(`/savesalesmen`, data);
}
export function updateListSalesmen(data) {
  return axiosInstance.post(`/updatesalesmen`, data);
}

export function getLanguageList(data) {
  return axiosInstance.get(`/getlanguage`, data);
}

export function getListSupplierList(data) {
  return axiosInstance.post(`/listsupplier`, data);
}
export function deleteListSupplier(data) {
  return axiosInstance.post(`/deletesupplier`, data);
}
export function createListSupplier(data) {
  return axiosInstance.post(`/savesupplier`, data);
}
export function updateListSupplier(data) {
  return axiosInstance.post(`/updatesupplier`, data);
}

export function getListCustomerList(data) {
  return axiosInstance.post(`/listcustomer`, data);
}
export function deleteListCustomer(data) {
  return axiosInstance.post(`/deletecustomer`, data);
}
export function createListCustomer(data) {
  return axiosInstance.post(`/savecustomer`, data);
}
export function updateListCustomer(data) {
  return axiosInstance.post(`/updatecustomer`, data);
}

export function getAllCustomerSync(data) {
  return axiosInstance.post(`/getallcustomer`, data);
}

export function createSaveMoloniProduct(data) {
  return axiosInstance.post(`/saveproduct`, data);
}

export function deleteProductMoloniProduct(data) {
  return axiosInstance.post(`/deleteproduct`, data);
}

export function updateSaveMoloniProduct(data) {
  return axiosInstance.post(`/updateproduct`, data);
}

export function getAllDocumentList(data) {
  return axiosInstance.post(`/listdocument`, data);
}

export function getAllDocumentSync(data) {
  return axiosInstance.post(`/getAllDocument`, data);
}

export function getDocumentDownloadPdf(data) {
  return axiosInstance.post(`/getdocumentpdf`, data);
}

export function getListCurrency(data) {
  return axiosInstance.get(`/listCurrency`, data);
}

export function getAllCurrencyList(data) {
  return axiosInstance.get(`/getCurrency`, data);
}

export function createSaveInvoice(data) {
  return axiosInstance.post(`/saveinvoice`, data);
}

export function getInvoiceList(data) {
  return axiosInstance.post(`/listinvoice`, data);
}

export function deleteInvoice(data) {
  return axiosInstance.post(`/deleteinvoice`, data);
}

export function getInvoice(data) {
  return axiosInstance.post(`/getinvoice`, data);
}
export function getAllInvoiceSync(data) {
  return axiosInstance.post(`/getallinvoice`, data);
}

export function getViewInvoice(data) {
  return axiosInstance.post(`/viewinvoice`, data);
}

export function updateInvoice(data) {
  return axiosInstance.post(`/updateinvoice`, data);
}

export function getCustomerAddressList(data) {
  return axiosInstance.post(`/getCustomer`, data);
}

export function getAllReceiptSync(data) {
  return axiosInstance.post(`/getallreceipt`, data);
}

export function getReceiptList(data) {
  return axiosInstance.post(`/listreceipt`, data);
}

export function deleteReceipt(data) {
  return axiosInstance.post(`/deletereceipt`, data);
}

export function createSavereceipt(data) {
  return axiosInstance.post(`/savereceipt`, data);
}
export function updateReceipt(data) {
  return axiosInstance.post(`/updatereceipt`, data);
}

export function viewReceipt(data) {
  return axiosInstance.post(`/viewreceipt`, data);
}

export function createSaveCreditNotes(data) {
  return axiosInstance.post(`/savecreditnotes`, data);
}

export function getCreditNotesList(data) {
  return axiosInstance.post(`/listcreditnotes`, data);
}

export function deleteCreditNotes(data) {
  return axiosInstance.post(`/deletecreditnotes`, data);
}

export function getCreditNotes(data) {
  return axiosInstance.post(`/getcreditnotes`, data);
}
export function getAllCreditNotesSync(data) {
  return axiosInstance.post(`/getallcreditnotes`, data);
}

export function updateCreditNotes(data) {
  return axiosInstance.post(`/updatecreditnotes`, data);
}

export function viewCreditNotes(data) {
  return axiosInstance.post(`/viewcreditnotes`, data);
}

export function createSaveDebitNotes(data) {
  return axiosInstance.post(`/savedebitnotes`, data);
}

export function getDebitNotesList(data) {
  return axiosInstance.post(`/listdebitnotes`, data);
}

export function deleteDebitNotes(data) {
  return axiosInstance.post(`/deletedebitnotes`, data);
}

export function getDebitNotes(data) {
  return axiosInstance.post(`/getdebitnotes`, data);
}
export function getAllDebitNotesSync(data) {
  return axiosInstance.post(`/getalldebitnotes`, data);
}

export function updateDebitNotes(data) {
  return axiosInstance.post(`/updatedebitnotes`, data);
}

export function viewDebitNotes(data) {
  return axiosInstance.post(`/viewdebitnotes`, data);
}

export function createSavesimplifiedInvoices(data) {
  return axiosInstance.post(`/savesimplifiedinvoices`, data);
}

export function getsimplifiedInvoicesList(data) {
  return axiosInstance.post(`/listsimplifiedinvoices`, data);
}

export function deletesimplifiedInvoices(data) {
  return axiosInstance.post(`/deletesimplifiedinvoices`, data);
}

export function getsimplifiedInvoices(data) {
  return axiosInstance.post(`/getsimplifiedinvoices`, data);
}
export function getAllsimplifiedInvoicesSync(data) {
  return axiosInstance.post(`/getallsimplifiedinvoices`, data);
}

export function updatesimplifiedInvoices(data) {
  return axiosInstance.post(`/updatesimplifiedinvoices`, data);
}

export function viewsimplifiedInvoices(data) {
  return axiosInstance.post(`/viewsimplifiedinvoices`, data);
}

export function createSaveDeliveryNotes(data) {
  return axiosInstance.post(`/savedeliverynotes`, data);
}

export function getDeliveryNotesList(data) {
  return axiosInstance.post(`/listdeliverynotes`, data);
}

export function deleteDeliveryNotes(data) {
  return axiosInstance.post(`/deletedeliverynotes`, data);
}

export function getDeliveryNotes(data) {
  return axiosInstance.post(`/getdeliverynotes`, data);
}
export function getAllDeliveryNotesSync(data) {
  return axiosInstance.post(`/getalldeliverynotes`, data);
}

export function updateDeliveryNotes(data) {
  return axiosInstance.post(`/updatedeliverynotes`, data);
}

export function viewDeliveryNotes(data) {
  return axiosInstance.post(`/viewdeliverynotes`, data);
}

export function createSaveBillLanding(data) {
  return axiosInstance.post(`/savebillsoflading`, data);
}

export function getBillLandingList(data) {
  return axiosInstance.post(`/listbillsoflading`, data);
}

export function deleteBillLanding(data) {
  return axiosInstance.post(`/deletebillsoflading`, data);
}

export function getBillLanding(data) {
  return axiosInstance.post(`/listbillsoflading`, data);
}
export function getAllBillLandingSync(data) {
  return axiosInstance.post(`/getallbillsoflading`, data);
}

export function updateBillLanding(data) {
  return axiosInstance.post(`/updatebillsoflading`, data);
}

export function viewBillLanding(data) {
  return axiosInstance.post(`/viewbillsoflading`, data);
}

export function createOwnAssetsMovementGuides(data) {
  return axiosInstance.post(`/saveownassetsmg`, data);
}

export function getOwnAssetsMovementGuidesList(data) {
  return axiosInstance.post(`/listownassetsmg`, data);
}

export function deleteOwnAssetsMovementGuides(data) {
  return axiosInstance.post(`/deleteownassetsmg`, data);
}

export function getOwnAssetsMovementGuides(data) {
  return axiosInstance.post(`/listownassetsmg`, data);
}
export function getAllOwnAssetsMovementGuidesSync(data) {
  return axiosInstance.post(`/getallownassetsmg`, data);
}

export function updateOwnAssetsMovementGuides(data) {
  return axiosInstance.post(`/updateownassetsmg`, data);
}

export function viewOwnAssetsMovementGuides(data) {
  return axiosInstance.post(`/viewownassetsmg`, data);
}

export function createWaybills(data) {
  return axiosInstance.post(`/savewaybills`, data);
}

export function getWaybillsList(data) {
  return axiosInstance.post(`/listwaybills`, data);
}

export function deleteWaybills(data) {
  return axiosInstance.post(`/deletewaybills`, data);
}

export function getWaybills(data) {
  return axiosInstance.post(`/listwaybills`, data);
}
export function getAllWaybillsSync(data) {
  return axiosInstance.post(`/getallwaybills`, data);
}

export function updateWaybills(data) {
  return axiosInstance.post(`/updatewaybills`, data);
}

export function getviewWaybills(data) {
  return axiosInstance.post(`/viewwaybills`, data);
}

export function createCustomerReturnNote(data) {
  return axiosInstance.post(`/savecustomerreturnnote`, data);
}

export function getCustomerReturnNoteList(data) {
  return axiosInstance.post(`/listcustomerreturnnote`, data);
}

export function deleteCustomerReturnNote(data) {
  return axiosInstance.post(`/deletecustomerreturnnote`, data);
}

export function getCustomerReturnNote(data) {
  return axiosInstance.post(`/listcustomerreturnnote`, data);
}
export function getAllCustomerReturnNoteSync(data) {
  return axiosInstance.post(`/getallcustomerreturnnote`, data);
}

export function updateCustomerReturnNote(data) {
  return axiosInstance.post(`/updatecustomerreturnnote`, data);
}

export function viewCustomerReturnNote(data) {
  return axiosInstance.post(`/viewcustomerreturnnote`, data);
}

export function createEstimates(data) {
  return axiosInstance.post(`/saveestimates`, data);
}

export function getEstimatesList(data) {
  return axiosInstance.post(`/listestimates`, data);
}

export function deleteEstimates(data) {
  return axiosInstance.post(`/deleteestimates`, data);
}

export function getEstimates(data) {
  return axiosInstance.post(`/getestimates`, data);
}
export function getAllEstimatesSync(data) {
  return axiosInstance.post(`/getallestimates`, data);
}

export function updateEstimates(data) {
  return axiosInstance.post(`/updateestimates`, data);
}

export function viewEstimates(data) {
  return axiosInstance.post(`/viewestimates`, data);
}

export function createInternalDocuments(data) {
  return axiosInstance.post(`/saveinternaldocuments`, data);
}

export function getInternalDocumentsList(data) {
  return axiosInstance.post(`/listinternaldocuments`, data);
}

export function deleteInternalDocuments(data) {
  return axiosInstance.post(`/deleteinternaldocuments`, data);
}

export function getInternalDocuments(data) {
  return axiosInstance.post(`/getinternaldocuments`, data);
}
export function getAllInternalDocumentsSync(data) {
  return axiosInstance.post(`/getallinternaldocuments`, data);
}

export function updateInternalDocuments(data) {
  return axiosInstance.post(`/updateinternaldocuments`, data);
}

export function viewInternalDocuments(data) {
  return axiosInstance.post(`/viewinternaldocuments`, data);
}

export function createInvoiceReceipts(data) {
  return axiosInstance.post(`/saveinvoicereceipts`, data);
}

export function getInvoiceReceiptsList(data) {
  return axiosInstance.post(`/listinvoicereceipts`, data);
}

export function deleteInvoiceReceipts(data) {
  return axiosInstance.post(`/deleteinvoicereceipts`, data);
}

export function getInvoiceReceipts(data) {
  return axiosInstance.post(`/getinvoicereceipts`, data);
}
export function getAllInvoiceReceiptsSync(data) {
  return axiosInstance.post(`/getallinvoicereceipts`, data);
}

export function updateInvoiceReceipts(data) {
  return axiosInstance.post(`/updateinvoicereceipts`, data);
}

export function viewInvoiceReceipts(data) {
  return axiosInstance.post(`/viewinvoicereceipts`, data);
}

export function createPaymentReturns(data) {
  return axiosInstance.post(`/savepaymentreturns`, data);
}

export function getPaymentReturnsList(data) {
  return axiosInstance.post(`/listpaymentreturns`, data);
}

export function deletePaymentReturns(data) {
  return axiosInstance.post(`/deletepaymentreturns`, data);
}

export function getPaymentReturns(data) {
  return axiosInstance.post(`/listpaymentreturns`, data);
}
export function getAllPaymentReturnsSync(data) {
  return axiosInstance.post(`/getallpaymentreturns`, data);
}

export function updatePaymentReturns(data) {
  return axiosInstance.post(`/updatepaymentreturns`, data);
}

export function viewPaymentReturns(data) {
  return axiosInstance.post(`/viewpaymentreturns`, data);
}



export function createPurchaseorder(data) {
  return axiosInstance.post(`/savepurchaseorder`, data);
}

export function getPurchaseorderList(data) {
  return axiosInstance.post(`/listpurchaseorder`, data);
}

export function deletePurchaseorder(data) {
  return axiosInstance.post(`/deletepurchaseorder`, data);
}

export function getPurchaseorder(data) {
  return axiosInstance.post(`/listpurchaseorder`, data);
}
export function getAllPurchaseorderSync(data) {
  return axiosInstance.post(`/getallpurchaseorder`, data);
}

export function updatePurchaseorder(data) {
  return axiosInstance.post(`/updatepurchaseorder`, data);
}

export function viewPurchaseorder(data) {
  return axiosInstance.post(`/viewpurchaseorder`, data);
}




export function createSupplierPurchaseOrder(data) {
  return axiosInstance.post(`/savesupplierpurchaseorder`, data);
}

export function getSupplierPurchaseOrderList(data) {
  return axiosInstance.post(`/listsupplierpurchaseorder`, data);
}

export function deleteSupplierPurchaseOrder(data) {
  return axiosInstance.post(`/deletesupplierpurchaseorder`, data);
}

export function getSupplierPurchaseOrder(data) {
  return axiosInstance.post(`/listsupplierpurchaseorder`, data);
}
export function getAllSupplierPurchaseOrderSync(data) {
  return axiosInstance.post(`/getallsupplierpurchaseorder`, data);
}

export function updateSupplierPurchaseOrder(data) {
  return axiosInstance.post(`/updatesupplierpurchaseorder`, data);
}

export function viewSupplierPurchaseOrder(data) {
  return axiosInstance.post(`/viewsupplierpurchaseorder`, data);
}



export function createSupplierInvoice(data) {
  return axiosInstance.post(`/savesupplierinvoice`, data);
}

export function getSupplierInvoiceList(data) {
  return axiosInstance.post(`/listsupplierinvoice`, data);
}

export function deleteSupplierInvoice(data) {
  return axiosInstance.post(`/deletesupplierinvoice`, data);
}

export function getSupplierInvoice(data) {
  return axiosInstance.post(`/listsupplierinvoice`, data);
}
export function getAllSupplierInvoiceSync(data) {
  return axiosInstance.post(`/getallsupplierinvoice`, data);
}

export function updateSupplierInvoice(data) {
  return axiosInstance.post(`/updatesupplierinvoice`, data);
}

export function viewSupplierInvoice(data) {
  return axiosInstance.post(`/viewsupplierinvoice`, data);
}



export function createSupplierSimplifiedInvoice(data) {
  return axiosInstance.post(`/savesuppliersimplifiedinvoice`, data);
}

export function getSupplierSimplifiedInvoiceList(data) {
  return axiosInstance.post(`/listsuppliersimplifiedinvoice`, data);
}

export function deleteSupplierSimplifiedInvoice(data) {
  return axiosInstance.post(`/deletesuppliersimplifiedinvoice`, data);
}

export function getSupplierSimplifiedInvoice(data) {
  return axiosInstance.post(`/listsuppliersimplifiedinvoice`, data);
}
export function getAllSupplierSimplifiedInvoiceSync(data) {
  return axiosInstance.post(`/getallsuppliersimplifiedinvoice`, data);
}

export function updateSupplierSimplifiedInvoice(data) {
  return axiosInstance.post(`/updatesuppliersimplifiedinvoice`, data);
}

export function viewSupplierSimplifiedInvoices(data) {
  return axiosInstance.post(`/viewsuppliersimplifiedinvoice`, data);
}



export function createSupplierCreditNotes(data) {
  return axiosInstance.post(`/savesuppliercreditnotes`, data);
}

export function getSupplierCreditNotesList(data) {
  return axiosInstance.post(`/listsuppliercreditnotes`, data);
}

export function deleteSupplierCreditNotes(data) {
  return axiosInstance.post(`/deletesuppliercreditnotes`, data);
}

export function getSupplierCreditNotes(data) {
  return axiosInstance.post(`/listsuppliercreditnotes`, data);
}
export function getAllSupplierCreditNotesSync(data) {
  return axiosInstance.post(`/getallsuppliercreditnotes`, data);
}

export function updateSupplierCreditNotes(data) {
  return axiosInstance.post(`/updatesuppliercreditnotes`, data);
}

export function viewSupplierCreditNotess(data) {
  return axiosInstance.post(`/viewsuppliercreditnotes`, data);
}



export function createSupplierDebitNotes(data) {
  return axiosInstance.post(`/savesupplierdebitnotes`, data);
}

export function getSupplierDebitNotesList(data) {
  return axiosInstance.post(`/listsupplierdebitnotes`, data);
}

export function deleteSupplierDebitNotes(data) {
  return axiosInstance.post(`/deletesupplierdebitnotes`, data);
}

export function getSupplierDebitNotes(data) {
  return axiosInstance.post(`/listsupplierdebitnotes`, data);
}
export function getAllSupplierDebitNotesSync(data) {
  return axiosInstance.post(`/getallsupplierdebitnotes`, data);
}

export function updateSupplierDebitNotes(data) {
  return axiosInstance.post(`/updatesupplierdebitnotes`, data);
}

export function viewSupplierDebitNotess(data) {
  return axiosInstance.post(`/viewsupplierdebitnotes`, data);
}




export function createSupplierReturnNotes(data) {
  return axiosInstance.post(`/savesupplierreturnnotes`, data);
}

export function getSupplierReturnNotesList(data) {
  return axiosInstance.post(`/listsupplierreturnnotes`, data);
}

export function deleteSupplierReturnNotes(data) {
  return axiosInstance.post(`/deletesupplierreturnnotes`, data);
}

export function getSupplierReturnNotes(data) {
  return axiosInstance.post(`/listsupplierreturnnotes`, data);
}
export function getAllSupplierReturnNotesSync(data) {
  return axiosInstance.post(`/getallsupplierreturnnotes`, data);
}

export function updateSupplierReturnNotes(data) {
  return axiosInstance.post(`/updatesupplierreturnnotes`, data);
}

export function viewSupplierReturnNotes(data) {
  return axiosInstance.post(`/viewsupplierreturnnotes`, data);
}




export function createSupplierReceipts(data) {
  return axiosInstance.post(`/savesupplierreceipts`, data);
}

export function getSupplierReceiptsList(data) {
  return axiosInstance.post(`/listsupplierreceipts`, data);
}

export function deleteSupplierReceipts(data) {
  return axiosInstance.post(`/deletesupplierreceipts`, data);
}

export function getSupplierReceipts(data) {
  return axiosInstance.post(`/listsupplierreceipts`, data);
}
export function getAllSupplierReceiptsSync(data) {
  return axiosInstance.post(`/getallsupplierreceipts`, data);
}

export function updateSupplierReceipts(data) {
  return axiosInstance.post(`/updatesupplierreceipts`, data);
}

export function viewSupplierReceipts(data) {
  return axiosInstance.post(`/viewsupplierreceipts`, data);
}



export function createSupplierWarrantyRequest(data) {
  return axiosInstance.post(`/savesupplierwarrantyrequest`, data);
}

export function getSupplierWarrantyRequestList(data) {
  return axiosInstance.post(`/listsupplierwarrantyrequest`, data);
}

export function deleteSupplierWarrantyRequest(data) {
  return axiosInstance.post(`/deletesupplierwarrantyrequest`, data);
}

export function getSupplierWarrantyRequest(data) {
  return axiosInstance.post(`/listsupplierwarrantyrequest`, data);
}
export function getAllSupplierWarrantyRequestSync(data) {
  return axiosInstance.post(`/getallsupplierwarrantyrequest`, data);
}

export function updateSupplierWarrantyRequest(data) {
  return axiosInstance.post(`/updatesupplierwarrantyrequest`, data);
}

export function viewSupplierWarrantyRequest(data) {
  return axiosInstance.post(`/viewsupplierwarrantyrequest`, data);
}



export function createGlobalGuides(data) {
  return axiosInstance.post(`/saveglobalguides`, data);
}

export function getGlobalGuidesList(data) {
  return axiosInstance.post(`/listglobalguides`, data);
}

export function deleteGlobalGuides(data) {
  return axiosInstance.post(`/deleteglobalguides`, data);
}

export function getGlobalGuides(data) {
  return axiosInstance.post(`/listglobalguides`, data);
}
export function getAllGlobalGuidesSync(data) {
  return axiosInstance.post(`/getallglobalguides`, data);
}

export function updateGlobalGuides(data) {
  return axiosInstance.post(`/updateglobalguides`, data);
}

export function viewGlobalGuides(data) {
  return axiosInstance.post(`/viewglobalguides`, data);
}

export function getSyncAllMoloniData(data) {
  return axiosInstance.post(`/sync-all-maloni-data`, data);
}
export function getSyncAllMoloniProductData(data) {
  return axiosInstance.post(`/sync-all-maloni-product-data`, data);
}

export function getSyncAllMoloniTpData(data) {
  return axiosInstance.post(`/sync-all-tp-to-maloni-data`, data);
}



